// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientQuestionnaire_root__1PCMw","header":"PatientQuestionnaire_header__3VDwM","info":"PatientQuestionnaire_info__25aNJ"};